// Minimal semver: supports '*', exact versions, '^x[.y[.z]]' and '~x.y[.z]'.
// Enough for plugin dependency ranges in v1; swap for the semver package if
// third-party plugins ever need full range syntax.
function parse(v) {
  const m = String(v).trim().match(/^v?(\d+)(?:\.(\d+))?(?:\.(\d+))?/)
  if (!m) return null
  return [Number(m[1]), Number(m[2] ?? 0), Number(m[3] ?? 0)]
}

function cmp(a, b) {
  for (let i = 0; i < 3; i++) {
    if (a[i] !== b[i]) return a[i] - b[i]
  }
  return 0
}

export function satisfies(version, range) {
  if (!range || range === '*' || range === 'latest') return true
  const v = parse(version)
  if (!v) return false
  const r = parse(range.replace(/^[\^~]/, ''))
  if (!r) return false
  if (range.startsWith('^')) {
    if (cmp(v, r) < 0) return false
    if (r[0] > 0) return v[0] === r[0]
    if (r[1] > 0) return v[0] === 0 && v[1] === r[1]
    return v[0] === 0 && v[1] === 0 && v[2] === r[2]
  }
  if (range.startsWith('~')) {
    return cmp(v, r) >= 0 && v[0] === r[0] && v[1] === r[1]
  }
  return cmp(v, r) === 0
}
